import { scrollStateReducer, useScrollState } from '@medly-components/utils';
import { useEffect, useReducer, useRef, type FC } from 'react';
import { FormWrapper } from './CaptureInfoForm.styled';
import { CaptureInfoFormActions } from './CaptureInfoFormActions';
import { CaptureInfoFormContent } from './CaptureInfoFormContent';
import { CaptureInfoFormHeader } from './CaptureInfoFormHeader';
import { ScrollContext } from './ScrollContext';
import type { CaptureInfoFormProps, CaptureInfoFormStaticProps } from './types';

const Component: FC<CaptureInfoFormProps> = ({ children, className }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [scrollState, dispatch] = useReducer(scrollStateReducer, { scrolledToTop: true, scrolledToBottom: false, scrollPosition: 0 });
    const handleScroll = useScrollState({ ref, scrollState, dispatch });

    useEffect(() => {
        setTimeout(() => {
            ref.current?.scrollTo({ top: 1 });
        }, 100);
    }, []);

    return (
        <ScrollContext.Provider value={{ scrollState, dispatch, ref }}>
            <FormWrapper ref={ref} className={className} onScroll={handleScroll}>
                {children}
            </FormWrapper>
        </ScrollContext.Provider>
    );
};

export const CaptureInfoForm: FC<CaptureInfoFormProps> & CaptureInfoFormStaticProps = Object.assign(Component, {
    Header: CaptureInfoFormHeader,
    Content: CaptureInfoFormContent,
    Actions: CaptureInfoFormActions
});
